import { render, staticRenderFns } from "./FileTextBoxSearch.vue?vue&type=template&id=4231e60d&scoped=true&"
import script from "./FileTextBoxSearch.vue?vue&type=script&lang=ts&"
export * from "./FileTextBoxSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4231e60d",
  null
  
)

export default component.exports